import { Region } from 'src/types/region'

import { TaxRate } from '@modules-deprecated/app/taxrates/types'

import { BookyVatRate } from '../types/bookkeepingTag'

interface GetTaxRateFromBookkeepingTagAnswerProps {
  answer: BookyVatRate
  hasVATdetected: boolean | undefined
  taxRates?: TaxRate[]
  region: Region | undefined
}

export const getTaxRateFromBookkeepingTagAnswer = ({
  answer,
  hasVATdetected,
  taxRates,
  region,
}: GetTaxRateFromBookkeepingTagAnswerProps): TaxRate | undefined => {
  if (!region) {
    return undefined
  }

  let taxRateAbbreviation: string | undefined

  if (region === 'local' && hasVATdetected === false) {
    taxRateAbbreviation = answer.local_vat_0_exempt
  } else {
    taxRateAbbreviation = answer[region]
  }

  return taxRates?.find((taxRate) => taxRate.predefinedTag === taxRateAbbreviation)
}
